// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_fieldset__tZNU5 {
  border: 1px solid #6ba7a8;
  padding: 12px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-width: unset;
  max-width: 100%;
  gap: 4px;
}
.styles_fieldset__tZNU5 legend {
  font-weight: 500;
  color: #6ba7a8;
  padding: 0 8px;
}
.styles_fieldset__tZNU5 div {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/TranscriptList/FilterSort/RenderFilters/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,QAAA;AACF;AAAE;EACE,gBAAA;EACA,cAAA;EACA,cAAA;AAEJ;AAAE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAEJ","sourcesContent":[".fieldset {\n  border: 1px solid #6ba7a8;\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  min-width: unset;\n  max-width: 100%;\n  gap: 4px;\n  legend {\n    font-weight: 500;\n    color: #6ba7a8;\n    padding: 0 8px;\n  }\n  div {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fieldset": `styles_fieldset__tZNU5`
};
export default ___CSS_LOADER_EXPORT___;
